import { LookupFields, UserFields } from "src/modules/modules.type";
import { FIELDS_TYPES } from "./type.config";
import { Moment } from "moment";
import { LookUpRecord, UserRecord } from "src/types/main";

export const aILogListName = "AILog";


export const aiNameFields = {
    [aILogListName]: {
        User: FIELDS_TYPES.USER,
        UserEmail: FIELDS_TYPES.STRING,
        ID: FIELDS_TYPES.ID,
        Card: FIELDS_TYPES.LOOKUP,
        Step: FIELDS_TYPES.STRING,
        Status: FIELDS_TYPES.STRING,
        Model: FIELDS_TYPES.STRING,
        ModelVersion: FIELDS_TYPES.STRING,
        EstimatedTokens: FIELDS_TYPES.NUMBER,
        PromptTokens: FIELDS_TYPES.NUMBER,
        CompletionTokens: FIELDS_TYPES.NUMBER,
        TotalTokens: FIELDS_TYPES.NUMBER,
        DurationMs: FIELDS_TYPES.NUMBER,
        RequestText: FIELDS_TYPES.STRING,
        ResponseText: FIELDS_TYPES.STRING,
        HasPII: FIELDS_TYPES.BOOLEAN,
        PiiFound: FIELDS_TYPES.STRING,
        AnonymizerApplied: FIELDS_TYPES.BOOLEAN,
        ErrorCode: FIELDS_TYPES.STRING,
        Created: FIELDS_TYPES.DATE,
        RequestTextPlain: FIELDS_TYPES.STRING,
    }
};

export type aiFieldsRecordType = {
    [aILogListName]: {
        User: UserFields;
        UserEmail: string;
        ID: number;
        Card: LookupFields;
        Step: string;
        Status: string;
        Model: string;
        ModelVersion: string;
        EstimatedTokens: number;
        PromptTokens: number;
        CompletionTokens: number;
        TotalTokens: number;
        DurationMs: number;
        RequestText: string;
        ResponseText: string;
        HasPII: boolean;
        PiiFound: string;
        AnonymizerApplied: boolean;
        ErrorCode: string;
        Created: Date;
        RequestTextPlain: string
    };
};

export type aiFieldsType = {
    [aILogListName]: {
        User: UserRecord;
        UserEmail: string;
        ID: number;
        Card: LookUpRecord;
        Step: string;
        Status: string;
        Model: string;
        ModelVersion: string;
        EstimatedTokens: number;
        PromptTokens: number;
        CompletionTokens: number;
        TotalTokens: number;
        DurationMs: number;
        RequestText: string;
        ResponseText: string;
        HasPII: boolean;
        PiiFound: string;
        AnonymizerApplied: boolean;
        ErrorCode: string;
        Created: Date;
        RequestTextPlain: string;
    };
};
